import { React, useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../../contexts/authContext';
import { useNavigate } from 'react-router-dom';

import { Modal, Textarea, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { TextInput, Loader } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconChevronLeft } from '@tabler/icons-react';

import AppHdWithLeftReturn from '../../../../composents/Headers/AppHeaders/AppHdWithReturnLeft/AppHdWithReturnLeft'
import SyndicRectangleButton from '../../../../composents/Buttons/Syndic/RectangleButton/RectangleButtonMain';
import AppDesktopLogo from '../../../../composents/Logo/AppDesktopLogo/AppDesktopLogo';


const ModifyMyAccount = () => {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const [ userData, setUserData ] = useState()
    const [opened, { open, close }] = useDisclosure(false);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const token = getToken();
            if (!token) {
                navigate("/app/login");
                return;
            }

            try {
                await getUser();
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const form = useForm({
        initialValues: {
            firstname : '',
            lastname : '',
            occupation : '',
            description : ''
        },

        validate : {
            lastname : (value) => (
                value.length < 1
                ? 'Renseignez votre nom'
                : value.length > 30 
                ? '30 caractères maximum' 
                : null
            ),
            firstname : (value) => (
                value.length < 1
                ? 'Renseignez votre prénom'
                : value.length > 30 
                ? '30 caractères maximum'
                : null
            ),
            occupation : (value) => (
                value.length > 100
                ? '100 caractères maximum'
                : null
            ),
            description : (value) => (
                value.length > 200
                ? '200 caractères maximum'
                : null
            )
        }
    })

    const getUser = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/getUser', {
                method: "GET",    
                headers: {
                    Authorization: `Bearer ${token}`
                    }
        });
            const data = await response.json()
            setUserData(data)
            console.log('data', data)
            form.setValues({
                firstname: data.firstname || "",
                lastname: data.lastname || "",
                occupation: data.occupation || "",
                description: data.company?.description || ""
              });
        }   catch (error) {
        }
    }

    const handleFormChange = (event) => {
        const { name, value } = event.currentTarget;
        form.setFieldValue( name, value );
    };
    
    const handleFormSubmit = async (values, _event) => {
        _event.preventDefault();
        console.log('data', values)
        try {
            const token = localStorage.getItem('token');
            const response = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/app/profile/edit", {
            
                method: "POST",
                body: JSON.stringify({
                    firstname: values.firstname,
                    lastname: values.lastname,
                    occupation: values.occupation,
                    description : values.description
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            const data = await response.json(); 
            setUserData(data);
            sessionStorage.setItem("user", JSON.stringify(data));
            open();
            setTimeout(() => {
                window.location.reload();
            }, 700);    
        } catch (error) {
        }
    }


    return(
        userData ?
            <>
                {isMobile ? (
                    <>
                        <form onSubmit={form.onSubmit(handleFormSubmit)}>
                            <AppHdWithLeftReturn>Modifier mon profil</AppHdWithLeftReturn>
                            <>
                               <div className="width90pCenter">
                                    <TextInput
                                        label="Prénom"
                                        placeholder={userData.firstname}
                                        onChange={handleFormChange}
                                        {...form.getInputProps('firstname')}
                                    />

                                    <div className="mrgB5"></div>

                                    <TextInput
                                        label="Nom"
                                        placeholder={userData.lastname}
                                        onChange={handleFormChange}
                                        {...form.getInputProps('lastname')}
                                    />

                                    <div className="mrgB5"></div>

                                    <TextInput
                                        label="Fonction"
                                        placeholder={userData.occupation || "Votre fonction"}
                                        onChange={handleFormChange}
                                        {...form.getInputProps('occupation')}
                                    />

                                    <div className="mrgB5"></div>

                                    <Textarea
                                        label={`Description de ${userData.company?.name || "votre société"}`}
                                        minRows={18}
                                        maxLength={200}
                                        placeholder={userData.company.description || "Ajouter description"}
                                        onChange={handleFormChange}
                                        {...form.getInputProps('description')}
                                    />

                                    <div className="mrgB5"></div>
                                </div>

                                <div className="mrgB20"></div>

                                <div className="width90pCenter">
                                        <SyndicRectangleButton type="submit">
                                            <p id="syndicChangesProfilInfoga4" className='noMrgTB'>Enregistrer</p>
                                        </SyndicRectangleButton> 
                                    
                                    {open
                                        ?   <Modal
                                                centered
                                                size="auto"
                                                opened={opened}
                                                onClose={close}
                                                withCloseButton={false}>
                                                <p className="txtCenter noMrgTB txt15 ">
                                                    Modifications sauvegardées
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }
                                </div>

                                <div className="mrgB30"></div> 
                            </>
                        </form>
                        <div className='mrgB75'/>
                    </>
                ) : (
                    <>
                        <AppDesktopLogo/>
                        <form onSubmit={form.onSubmit(handleFormSubmit)}>
                            <div className="offer-desktop-page-bg" style={{ padding: "0 0 60px", alignItems: "flex-start", flexDirection: "column" }}>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", margin: "40px auto 20px", width: "39%" }}>
                                <button
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    style={{
                                        height: 36,
                                        width: 110,
                                        opacity: 0.9,
                                        backgroundColor: "#FFFFFF",
                                        borderRadius: 50,
                                        border: "none",
                                        padding: "0 12px",
                                        boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                                        cursor: "pointer",
                                        justifySelf: "start",
                                    }}
                                >
                                    <div className="horizontal iCenter">
                                        <IconChevronLeft width={20} />
                                        <p className="txt18 medium noMrgTB mrgL5">Retour</p>
                                    </div>
                                </button>
                                <h2 className="noMrgTB" style={{ gridColumn: 2, justifySelf: "center" }}>Modifier mon profil</h2>
                                <div />
                            </div>
                            <div className="offer-form-card" style={{ width: "39%" }}>
                                <div>

                                    <TextInput
                                        label="Prénom"
                                        placeholder={userData.firstname}
                                        onChange={handleFormChange}
                                        size='md'
                                        {...form.getInputProps('firstname')}
                                    />

                                    <div className="mrgB10"></div>

                                    <TextInput
                                        label="Nom"
                                        placeholder={userData.lastname}
                                        onChange={handleFormChange}
                                        size='md'
                                        {...form.getInputProps('lastname')}   
                                    />

                                    <div className="mrgB10"></div>

                                    <TextInput
                                        size='md'
                                        label="Fonction"
                                        placeholder={userData.occupation || "Votre fonction"}
                                        onChange={handleFormChange}
                                        {...form.getInputProps('occupation')}
                                    />

                                    <div className="mrgB10"></div>

                                    <Textarea
                                        size='md'
                                        label={`Description de ${userData.company?.name || "votre société"}`}
                                        minRows={6}
                                        maxLength={200}
                                        placeholder={userData.company.description || "Ajouter description"}
                                        onChange={handleFormChange}
                                        {...form.getInputProps('description')}
                                    />
                                </div>

                                <div className="mrgB30"></div>

                                <div className="txtCenter">
                                    <Button type="submit" color="dark" radius="xl" size="md" w={200} styles={{ label: { fontSize: 16, fontWeight: 500 } }}>
                                        Enregistrer
                                    </Button>


                                    {open
                                        ?   <Modal
                                                centered
                                                size="auto"
                                                opened={opened}
                                                onClose={close}
                                                withCloseButton={false}>
                                                <p className="txtCenter noMrgTB txt16 ">
                                                    Modifications sauvegardées
                                                </p>
                                            </Modal>
                                        :   ""
                                    }
                                </div>
                            </div>
                            </div>
                        </form>
                    </>
                )}
            </>
        : 
        <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className='mrgT5'>Chargement ...</div>
        </div>  
    )   
}

export default ModifyMyAccount;